/*eslint-env jquery*/
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { toastr } from 'react-redux-toastr'
import MySweetAlert from '../Shared/MySweetAlert'
import Loading from '../Shared/Loading'
import Select from 'react-select'
import { messagesService } from '../../_services/messages.service'
import { FaPlus } from 'react-icons/fa'
import { FiEdit } from 'react-icons/fi'
import { FiTrash2 } from 'react-icons/fi'
import  config  from '../../config'
import NumberFormat from 'react-number-format'
import MessageModal from './MessageModal'
// Import React Table
import matchSorter from 'match-sorter'
import ReactTable from "react-table"

import { Input } from 'antd'
import messageTypes from '../../_constants/messageTypes'

import moment from 'moment-jalaali'
moment.loadPersian({ dialect: 'persian-modern' })


const requestData = (pageSize, page, sorted, filtered, dto) => {
  // // console.log(dto)
  return new Promise(async (resolve, reject) => {

    // var dto = {};
    dto["pageSize"] = pageSize;
    dto["page"] = page;
    dto["ProjectStatus"] = 0;
    // console.log(JSON.stringify(dto));

    var result = [];
    await messagesService.getAll(JSON.stringify(dto))
      .then((res) => {
        // // console.log(res)
        result = res.data

      })
      .catch((err) => {
        // setTimeout(() => requestData(pageSize, page, sorted, filtered, dto), 5000);
        // // console.log(err);

      })


    setTimeout(() => resolve(result), 100);
  });
};

class Projects extends Component {

  constructor(props, context) {
    super(props, context);

    var pageSize = parseInt(localStorage.getItem('pageSizeForProjects'), 0)
    this.state = {
      initialItems: [],
      messages: [],
      loading: true,
      confirmDeleteShow: false,
      requiredItem: 0,
      deleteItemIndex: 0,
      model: {},
      modal: false,
      pageSize: pageSize ? pageSize : 10,

      dto: { page: 0, pageSize: pageSize },
    }

    // this.getData()
  }

  fetchData = (state, instance) => {

    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(state.pageSize, state.page, state.sorted, state.filtered, this.state.dto).then(
      res => {
        // console.log(res);

        if (res.data) {
          // var pageSize = res.data.result.length > state.pageSize ? state.pageSize : res.data.result.length;
          // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
          this.setState({
            data: res.data,
            pages: Math.ceil(res.totalRecords / state.pageSize),
            loading: false,
            modal: false,
            searchModal: false,
            pageSize: state.pageSize,
          });
        }
      }
    ).catch((err) => {
      // console.log(err);

      this.setState({ loading: false, searchModal: false });
    })
  }

  handleSweetAlertHide = () => {
    this.setState({ confirmDeleteShow: false });
  }

  // getData() {
  //   messagesService.getAll()
  //     .then((res) => {
  //       // console.log(res.data)
  //       this.setState({ initialItems: res.data, messages: res.data, loading: false });
  //     })
  // };

  handleError(error) {
    this.setState({ loading: false });
    // // toastr.warning('مشکلی پیش آمد', error);
  }

  handleDelete = (e) => {
    this.setState({ confirmDeleteShow: true, model: e });
  }

  handleConfirmDelete = () => {
    this.setState({ loading: true, confirmDeleteShow: false });
    // console.log(this.state.model);
    messagesService.delete(this.state.model.id)
      .then((res) => {
        toastr.success('حذف پیام ', 'پیام با موفقیت حذف شد');
        this.table.fireFetchData();
      })
      .catch((error) => {
        this.handleError(error)
      });
  }

  _handleSearch = (e) => {
    let searcjQery = e.target.value.toLowerCase(),
      displayedItems = this.state.initialItems.filter((el) => {
        let searchValue = el.name.toLowerCase();
        return searchValue.indexOf(searcjQery) !== -1;
      })
    this.setState({
      messages: displayedItems
    })
  }

  _handleCancelSearch = (e) => {
    document.getElementById("searchInput").value = '';
    this.setState({
      messages: this.state.initialItems
    })
  }

  handleModalShow = (i) => {

    if (i) {
      this.setState({ modal: true, model: i });
    } else {
      let _model = {
        title: '',
        text: '',
        messageType: ''
      }
      this.setState({ modal: true, model: _model });
    }

  }

  handleModalClose = () => {

    this.setState({ modal: false });

  }

  handleModalCloseAndReload = () => {

    this.setState({ modal: false });

    this.table.fireFetchData();

  }

  render() {
    const { loading, data, pages, pageSize, dto, modal, model } = this.state;
    return (
      <div>

        <div className="row">
          <div className="col-lg-12">
            <a onClick={() => this.handleModalShow(undefined)} className="btn btn-primary btn-sm" style={{ float: 'right' }}>
              <FaPlus size="16px" style={{ verticalAlign: 'middle' }} />&nbsp;ارسال پیام جدید</a>
          </div>
        </div>

        <div className="row table-container" style={{ marginTop: 0 }}>
          <ReactTable


            manual
            data={data}
            pages={pages}
            loading={loading}
            onFetchData={this.fetchData}
            ref={(instance) => { this.table = instance; }}
            sorted={this.state.sorted}
            onSortedChange={(newSort, column) => {
              this.setState({ sorted: newSort });
            }}
            onPageSizeChange={pageSize => {
              // const { dispatch } = this.props;
              // dispatch( setPageSize(pageSize) )
              localStorage.setItem('pageSizeForProjects', pageSize);
              // this.setState({ page: 0 });
            }}
            page={this.state.page}
            onPageChange={page => this.setState({ page })}

            defaultPageSize={pageSize}
            previousText='صفحه قبل'
            nextText='صفحه بعد'
            loadingText='در حال بارگذاری ...'
            noDataText='نتیجه ای یافت نشد'
            pageText='صفحه'
            ofText='از'
            rowsText='تعداد نمایش'
            getTableProps={() => ({ style: { display: 'block' } })}
            getTrProps={(state, rowInfo, column, instance) => {
              const newSelected = Object.assign({}, this.state.selected);
              const selected = rowInfo ? newSelected[rowInfo.original.id] : false;
              return {
                style: {
                  backgroundColor: selected && "#5079F7",
                  color: selected && 'white',
                }
              }
            }}
            columns={[
              {
                Header: "ردیف",
                id: "row",
                maxWidth: 50,
                filterable: false,
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                className: "numberFa",
                Cell: (row) => {
                  return row.index + 1;
                }
              },
              {
                Header: "عنوان پیام",
                accessor: "title",
                id: "title",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["title.name"] }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />
              },
              {
                Header: "نوع ارسال",
                accessor: "messageType",
                id: "messageType",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["messageType"] }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
                Cell: (row) => (
                  <span className={"message-type-" + row.original.messageType}>
                    {messageTypes.filter(el => el.value === row.original.messageType)[0].label}
                  </span>
                )
              },
              {
                Header: "تاریخ شروع نمایش",
                accessor: "startDate",
                id: "startDate",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["startDate"] }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
                Cell: (row) => (
                  row.original.startDate ? moment(row.original.startDate, "YYYY/M/D H:m").format("jYYYY/jM/jD") : ' - '
                )
              },
              {
                Header: "تاریخ اتمام نمایش",
                accessor: "endDate",
                id: "endDate",
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                filterMethod: (filter, rows) =>
                  matchSorter(rows, filter.value, { keys: ["endDate"] }),
                filterAll: true,
                Filter: ({ onChange }) =>
                  <Input placeholder="" allowClear onChange={event => onChange(event.target.value)} />,
                Cell: (row) => (
                  row.original.endDate ? moment(row.original.endDate, "YYYY/M/D H:m").format("jYYYY/jM/jD") : ' - '
                )
              },
              {
                Header: "ویرایش",
                accessor: 'id',
                style: { display: 'flex', alignItems: 'center', justifyContent: 'center' },
                sortable: false,
                Filter: ({ filter, onChange }) =>
                  <Link to="/admin/messages/new" className="btn btn-primary react-table-add-btn">
                    <span>
                      <FaPlus size="16px" />
                      <span>افزودن پیام جدید</span>
                    </span>
                  </Link>,
                Cell: row => (
                  <div>
                    <a onClick={() => this.handleModalShow(row.original)} className="btn btn-sm btn-simple btn-success bmd-ripple bmd-flat-btn" rel="tooltip" data-original-title="ویرایش"><FiEdit size="24px" /></a>
                    <a onClick={() => this.handleDelete(row.original)} className="btn btn-sm btn-simple btn-danger bmd-ripple bmd-flat-btn delete-btn" data-original-title="حذف" rel="tooltip"><FiTrash2 size="24px" /></a>
                  </div>
                )
              }
            ]}
            className="-striped -highlight"
          />

        </div>

        <MySweetAlert
          show={this.state.confirmDeleteShow}
          onCancel={this.handleSweetAlertHide}
          onConfirm={this.handleConfirmDelete}
          title={"آیا از حذف پیام این مطمئن هستید؟"}
        >
        </MySweetAlert>

        <MessageModal data={model} open={modal} handleModalClose={() => this.handleModalClose} handleModalCloseAndReload={() => this.handleModalCloseAndReload()} />

        {/* {loading ? <Loading /> : ''} */}
      </div>
    );
  }
}

export default Projects;
